// src/stage2/collision/CollisionStore.jsx
import * as THREE from 'three';

export const playgroundColliders = [];
export const groundMeshes = [];

export function buildPlaygroundColliders(root) {
  playgroundColliders.length = 0;
  groundMeshes.length = 0;

  root.traverse((obj) => {
    if (!obj.isMesh) return;

    const name = (obj.name || '').toLowerCase();

    // --- 1. Treat terrain + playground pad as walkable ground only ---
    const isGround =
      name.includes('Ground_Terrain') ||   // hills
      obj.name === 'Cylinder.017' ||       // your playground asphalt
      name.includes('terrain');

    if (isGround) {
      groundMeshes.push(obj);
      return; // DO NOT create colliders for these
    }

    // --- 2. Big static building colliders only ---
    const isBigStatic =
      name.includes('HighSchool.001') ||
      name.includes('school');

    if (!isBigStatic) {
      // ignore swings, seesaw, posts, etc.
      return;
    }

    // --- 3. Create collider for big structures ---
    const box = new THREE.Box3().setFromObject(obj);

    const size = new THREE.Vector3();
    box.getSize(size);
    if (Math.max(size.x, size.y, size.z) < 0.2) return; // ignore tiny junk

    box.expandByScalar(-0.1); // shrink slightly so it's smooth to walk by
    playgroundColliders.push(box);
  });

  console.log(
    `Colliders: ${playgroundColliders.length}, Ground: ${groundMeshes.length}`
  );
}
